module.exports = __webpack_public_path__ + "72885595a80fb9d1e757393e457d8700.js";